import cx from 'classnames';
import Select, { Props as SelectProps } from 'react-select';
import { t } from '../../../i18n';

import { FormFieldProps } from '../Base';
import { Label } from '../Label/Label';

interface SelectOption {
  value: string;
  label: string;
}

interface Props<T> extends SelectProps<T, false>, Omit<FormFieldProps<SelectOption>, 'name' | 'value'> {}

export const SingleSelectField = <T extends unknown>(props: Props<T>): JSX.Element => {
  const { id, name, label, placeholder, className, ...rest } = props;

  return (
    <div className={cx('SelectField', className)}>
      {label && <Label classNamePrefix="SelectField" id={id} label={label} />}
      <Select
        id={id}
        name={name}
        classNamePrefix="SelectField"
        menuPlacement="auto"
        placeholder={placeholder || t('SelectField.placeholder')}
        loadingMessage={() => t('SelectField.loadingMessage')}
        noOptionsMessage={() => t('SelectField.noOptionsMessage')}
        {...rest}
      />
    </div>
  );
};
